import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { uploadTemporaryImage } from "../../../api/articles";
import { V3GenericErrorHandler } from "../../../api/error-handler";

export const getUploadTemporaryImageMutation = () => useMutation({
    mutationFn: uploadTemporaryImage,
    onError: V3GenericErrorHandler(toast.error),
});